
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
/* eslint react/no-unescaped-entities: 0 */
import Head from 'next/head'

import { useTranslate } from 'hooks'

import css from './retailer-terms.module.scss'

const TermsAndConditions = () => {
  const { t } = useTranslate('common')
  return (
    <main className={css.container}>
      <Head>
        <title>{t('page_title.retailer_terms')}</title>
      </Head>
      <div className="c13 doc-content">
        <p className="c24">
          <span className="c31 c12">Version date: </span>
          <span className="c35">1 June 2023</span>
        </p>
        <p className="c28 c33">
          <span className="c0" />
        </p>
        <p className="c20">
          <span className="c3">MARKATO HK LIMITED</span>
        </p>
        <p className="c16">
          <span className="c3" />
        </p>
        <a id="t.dd6412ac07665d5a3d3d62c5d8d804b04d1ca58e" />
        <a id="t.0" />
        <table className="c39">
          <tbody>
            <tr className="c36">
              <td className="c32" colSpan={1} rowSpan={1}>
                <p className="c24">
                  <span className="c3">TERMS OF SERVICE FOR RETAILERS</span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p className="c16">
          <span className="c0" />
        </p>
        <p className="c16">
          <span className="c3" />
        </p>
        <p className="c16">
          <span className="c3" />
        </p>
        <a id="id.gjdgxs" />
        <p className="c4">
          <span className="c0" />
        </p>
        <p className="c28 c9 c38" id="h.30j0zll">
          <span className="c3">TERMS OF SERVICE FOR RETAILERS ("Retailer Terms")</span>
        </p>
        <ol className="c1 lst-kix_list_1-0 start" start={1}>
          <li className="c7 c9 li-bullet-0">
            <h1 style={{ display: 'inline' }}>
              <span className="c3">Overview</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c6 li-bullet-0">
            <span className="c0">Welcome to Markato!</span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              Thank you for your interest in becoming a retailer on the Markato wholesale online marketplace, accessible
              through our websites:{' '}
            </span>
            <span>www.markato.com</span>
            <span className="c0">
              &nbsp;(or at any address that may be substituted for this one) (collectively, the “
            </span>
            <span className="c3">Site</span>
            <span className="c0">”) and, where available, our mobile applications (collectively, the “</span>
            <span className="c3">Application</span>
            <span className="c0">
              ”), and accessing and using the functionalities and services provided via the Site and/or the Application
              (together, the “
            </span>
            <span className="c3">Services</span>
            <span className="c0">”). </span>
          </li>
          <li className="c6 li-bullet-0">
            <span>Throughout these Retailer Terms, the terms “</span>
            <span>Markato</span>
            <span>”, "</span>
            <span>our</span>
            <span>", “</span>
            <span>us</span>
            <span>”, and/or “</span>
            <span>we</span>
            <span>” shall refer to </span>
            <span>Markato HK Limited</span>
            <span>
              &nbsp;(a company incorporated in Hong Kong (company number 3150358) with its registered office at{' '}
            </span>
            <span>Unit 1603, 16</span>
            <span>th</span>
            <span>&nbsp;Floor, The L. Plaza, 367 - 375 Queen’s Road Central, Sheung Wan, Hong Kong</span>
            <span>, and its Affiliates. The terms "</span>
            <span>Retailer</span>
            <span>", "</span>
            <span>user</span>
            <span>", “</span>
            <span>you</span>
            <span>” and/or “</span>
            <span>your</span>
            <span className="c0">” shall refer to you as a user of the Services as a Retailer. </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              The purpose of the Site, Application and Services is to bring eligible Brands into contact with eligible
              Retailers, for the purposes of enabling Brands to sell, and Retailers to purchase, a selection of curated
              products via the Services.
            </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              The sale of products via the Services shall take place as between the relevant Brand and Retailer (with
              such Brands and Retailers deciding along, at their discretion, on whether or not to enter into an order
              for such products).
            </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              Please note that Markato: (i) is neither a seller, nor a reseller, nor the owner of the products that are
              distributed via the Services; (ii) never enters into possession of the products that are put up for sale;
              (iii) does not hold the products in stock; and (iv) does not hold the products as a custodian or trustee
              of any kind. Markato cannot be held liable for any actions or omissions potentially committed by a Brand
              or by a Retailer in respect of their use of the Site, Application or Services.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-0" start={2}>
          <li className="c7 li-bullet-0">
            <h1 style={{ display: 'inline' }}>
              <span className="c3">TERMS OF ACCEPTANCE</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c6 li-bullet-0">
            <span className="c0">These Retailer Terms, along with:</span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">any Retailer Addendum that we have agreed with you (if any); and</span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">our Privacy Policy</span>
          </li>
        </ol>
        <p className="c11">
          <span className="c0">
            (together, the "Terms of Service"), shall govern your acquisition of products as a Retailer through the
            Services, and the terms on which we shall make the Services available to you. To the extent of any
            inconsistency between the components of the Terms of Service, such inconsistency shall be resolved in the
            following order of priority: Retailer Addendum, Privacy Policy, Retailer Terms.
          </span>
        </p>
        <ol className="c1 lst-kix_list_1-1" start={2}>
          <li className="c6 li-bullet-0">
            <span className="c0">
              We recommend that you carefully review the Terms of Service prior to submitting an application for a
              Retailer Account (defined below). If you have any questions about any of the Terms of Service please
              contact{' '}
            </span>
            <span>support@markato.com</span>
            <span className="c0">&nbsp;</span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              By registering to become a user of the Services as a Retailer, or using the Services:
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              you acknowledge and agree that you have read, understood and accepted the Terms of Service, including the
              Retailer Terms and our [Privacy Policy]; and
            </span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">
              you acknowledge and agree that you will be bound by and comply with the Terms of Service. Do not proceed
              with registering for an Account, or using the Services, if you do not understand and accept the Terms of
              Service in their entirety.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={4}>
          <li className="c6 li-bullet-0" id="h.1fob9te">
            <span className="c0">
              We reserve the right to amend any part of the Terms of Services, at any time, by posting the revised
              version of the Terms of Services on the Site, with an updated revision date. The changes will become
              effective, and shall be deemed accepted by you, the first time you use the Services after the initial
              posting of the revised Terms of Services, and shall apply on a going-forward basis with respect to
              transactions initiated after the posting date. You acknowledge that it is your responsibility to check the
              Terms of Services periodically for changes.
            </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              If you do not agree with any amendments to the Terms of Services, your sole and exclusive remedy is to
              terminate your use of the Services and close your Retailer Account. You agree that neither we nor any
              other Indemnified Party shall be liable to you or any third party for any Losses suffered as a result of
              any amendment of the Terms of Service.
            </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">Capitalized terms used herein are defined in Paragraph 26, below.</span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-0" start={3}>
          <li className="c7 c9 li-bullet-0">
            <h1 id="h.3znysh7" style={{ display: 'inline' }}>
              <span className="c3">Account Registration – Retailer Account</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c7 c9 li-bullet-0">
            <h2 id="h.2et92p0" style={{ display: 'inline' }}>
              <span className="c3">Retailer Account</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              To acquire products through the Services as a Retailer, you must submit an application to become a
              retailer and be approved by Markato for an account (“
            </span>
            <span className="c3">Retailer Account</span>
            <span className="c0">”). </span>
          </li>
          <li className="c2 li-bullet-1" id="h.tyjcwt">
            <span className="c0">
              When registering your Retailer Account, you must provide complete, accurate, up-to-date and not misleading
              information for all required elements on the registration page (including your full legal name and
              appropriate licenses and registrations applicable to your acquisition of Products (where applicable)).{' '}
            </span>
          </li>
          <li className="c2 li-bullet-2" id="h.3dy6vkm">
            <span className="c0">
              In addition, you must provide us, on an ongoing basis, with such additional information that we may
              reasonably request in relation to your application for, or operation or maintenance of, a Retailer Account
              and/or use the Services, including any information that we require in order to comply with our obligations
              under applicable law (e.g. for the purposes of identity verification and the detection of money
              laundering, terrorist financing, fraud, or any other financial crime).
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              You represent and warrant that any and all Retailer Information provided to us is complete, accurate,
              up-to-date and not misleading in any respect. If any such information changes, it is your obligation to
              update such information as soon as possible and provide such updates to us.{' '}
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              You acknowledge that your access to the Services may be altered as a result of the Retailer Information
              that you provide to us.
            </span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">
              If any (or we suspect that any) of the Retailer Information is not complete, accurate, or up-to-date, or
              is misleading, in any respect, or you fail to provide updates to any Retailer Information that you have
              provided to us to ensure that it is complete, accurate, up-to-date and not misleading in any respect on a
              timely basis, we may suspend your ability to use the Services or close your Retailer Account at our
              discretion.
            </span>
          </li>
          <li className="c2 li-bullet-1" id="h.1t3h5sf">
            <span className="c0">
              You acknowledge that we may use your Retailer Information for one or more of the following purposes, and
              authorise us to do so:
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-3 start" start={1}>
          <li className="c14 li-bullet-0">
            <h4 id="h.4d34og8" style={{ display: 'inline' }}>
              <span className="c0">
                exercising our rights or performing our obligations under the Terms of Service;
              </span>
            </h4>
          </li>
          <li className="c14 li-bullet-0">
            <h4 style={{ display: 'inline' }}>
              <span className="c12">
                enabling us to procure services from Intermediary Service Providers that are reasonably necessary for
                the performance of the Services (and complying with out obligations to disclose certain Retailer
                Information to such Intermediary Service Providers);
              </span>
            </h4>
          </li>
          <li className="c14 li-bullet-0">
            <h4 style={{ display: 'inline' }}>
              <span className="c12">complying with the requirements of</span>
              <span>&nbsp;any</span>
              <span className="c0">
                &nbsp;Intermediary Service Provider, credit reference and fraud prevention or financial crime agencies,
                Regulatory Authorities or applicable laws, including:
              </span>
            </h4>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-4 start" start={1}>
          <li className="c29 c28 li-bullet-0">
            <span className="c0">
              making enquiries, directly or through third parties, that we consider necessary to verify your identity or
              the information that you have provided; and
            </span>
          </li>
          <li className="c28 c29 li-bullet-0">
            <span className="c0">
              monitoring, identifying, preventing, investigating or reporting suspicious or illegal activity (including
              in relation to fraud or money laundering), and analysing and managing the risk of the same, including by
              way of conducting authorisations and screening checks;
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-3" start={4}>
          <li className="c14 li-bullet-0">
            <h4 style={{ display: 'inline' }}>
              <span className="c0">assessing financial, information security, sector, credit and insurance risks;</span>
            </h4>
          </li>
          <li className="c14 li-bullet-0">
            <h4 style={{ display: 'inline' }}>
              <span className="c0">assessing any breach of or enforcing the Terms of Service;</span>
            </h4>
          </li>
          <li className="c14 li-bullet-0">
            <h4 style={{ display: 'inline' }}>
              <span className="c0">recovering any debt that arises in relation to a party's insolvency;</span>
            </h4>
          </li>
          <li className="c14 li-bullet-0">
            <h4 style={{ display: 'inline' }}>
              <span className="c0">
                maintaining, testing and developing customer relationships, services and systems; and
              </span>
            </h4>
          </li>
          <li className="c14 li-bullet-0">
            <h4 style={{ display: 'inline' }}>
              <span className="c0">
                analysing your personal information and/or usage of the Services (in anonymised and aggregated format)
                for the purposes of developing and improving the Services.
              </span>
            </h4>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2" start={8}>
          <li className="c2 li-bullet-2">
            <span className="c0">
              You acknowledge &nbsp;and agree that we may disclose your Retailer Information to our Representatives, our
              Affiliates and their Representatives, Intermediary Service Providers, credit reference and fraud
              prevention or financial crime agencies, Regulatory Authorities, and other third parties, in each case for
              the purpose of &nbsp;providing the Services (or exercising our rights or performing our obligations under
              these Retailer Terms), including for the purposes set out in Paragraph 3.1.7. In each case we shall, and
              shall use our &nbsp;reasonable endeavours to procure that each other person to whom we disclose your
              Retailer Information shall, treat your Retailer Information as strictly confidential and not use or
              disclose your Retailer Information other than for the purpose of providing the Services (or exercising our
              rights or performing our obligations under these Retailer Terms, or complying with the requirements of any
              Intermediary Service Provider, credit reference and fraud prevention or financial crime &nbsp;agencies,
              Regulatory Authorities or applicable laws). Any such disclosures shall remain subject to the terms of our
              Privacy Policy.
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              We reserve the right to maintain your Retailer Account registration information after you close your
              Retailer Account for business and regulatory compliance purposes, subject to applicable laws.
            </span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">
              Markato will use good faith efforts to review your application to become a Retailer as soon as possible.
              You acknowledge that Markato is only able to accept a limited number of Retailers at any given time, and
              that Markato is not obligated to accept you as a Retailer. You hereby release Markato from any liability
              regarding the acceptance process.
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              We reserve the right to suspend or close your Retailer Account (or remove or block your acquisition of one
              or more Products) in our sole and absolute discretion, at any time, including where we reasonably suspect
              that you have breached any of the Terms of Services, without notice and without liability.
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              You may close your Retailer Account at any time using the functionality made available via the Services.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={2}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Eligibility</span>
            </h2>
          </li>
          <li className="c6 li-bullet-0" id="h.2s8eyo1">
            <span className="c0">
              In order to be eligible to open a Retailer Account or use the Services you must meet (and you represent
              and warrant that you do meet), the following eligibility criteria:
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              If you are an individual, you must be at least 18 years of age, have the capacity to accept the Retailer
              Terms, and not have been previously suspended or removed from access to the Services or any other service
              or product offered by Markato or any of its Affiliates.
            </span>
          </li>
          <li className="c2 li-bullet-1" id="h.17dp8vu">
            <span className="c0">If you are registering to use the Services on behalf of a legal entity then:</span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-3 start" start={1}>
          <li className="c10 li-bullet-0">
            <span className="c0">
              you must be duly authorised by such legal entity to act on its behalf for the purpose of entering into the
              Retailer Terms;
            </span>
          </li>
          <li className="c10 li-bullet-0">
            <span className="c0">
              the legal entity must be duly organised and validly existing under the laws of the jurisdiction of its
              organisation; and
            </span>
          </li>
          <li className="c10 li-bullet-0">
            <span className="c0">
              the legal entity must not have been (and each of its Affiliates must not have been) previously suspended
              or removed from access to the Services or any other service or product offered by Markato or any of its
              Affiliates.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2" start={3}>
          <li className="c2 li-bullet-1">
            <span className="c0">You will not be using the Services for any illegal activity.</span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={4}>
          <li className="c6 li-bullet-0">
            <span className="c0">
              If we determine that you do not fulfil any of the above criteria then we may suspend your ability to use
              the Services or close your Retailer Account at our discretion, without notice and without liability.
            </span>
          </li>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Your Retailer Account: security of user information</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              You may access your Retailer Account (and the Services) directly via the Site or the Application, or by
              such other mode of access that Markato may prescribe from time to time, using the Retailer Account names,
              User IDs, passwords, and other security features ("
            </span>
            <span className="c3">User Credentials and Security Passwords</span>
            <span className="c0">
              ") made available to you by Markato for the purposes of enabling you to access your Retailer Account (and
              the Services).{' '}
            </span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">
              You are responsible for maintaining the confidentiality and security of any and all User Credentials and
              Security Passwords, which includes the enabling of all relevant security features. You are responsible for
              keeping your email address up to date in your Retailer Account profile.
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              You are only permitted to access your Retailer Account using your own User Credentials and Security
              Passwords. You must ensure that your Retailer Account is not used by any other third party, and must not
              share your User Credentials and Security Passwords with any third party. You are solely responsible for
              all activity on your Retailer Account.
            </span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">
              You agree to notify Markato immediately if you become aware of any breach of security, loss, theft or
              unauthorised use of your User Credentials and Security Passwords, or unauthorised use of the Services via
              your Retailer Account, or any other breach of security regarding the Services. Markato will not be liable
              for any loss or damage arising from your failure to protect your Retailer Account or your User
              information.
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Markato reserves the right to suspend your ability to use the Services or close your Retailer Account if
              we suspect that the person logged into your Retailer Account is not you, or become aware of or suspect
              that there has been any breach of security, loss, theft or unauthorised use of your User Credentials and
              Security Passwords.
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              In order to access your Retailer Account (and the Services) you must have the necessary equipment (such as
              a computer or smartphone) and access to the Internet. You are solely responsible for your own hardware
              used to access the Services and are solely liable for the integrity and proper storage of any data
              associated with the Services that is stored on your own hardware. You are responsible for taking
              appropriate action to protect your hardware and data from viruses and malicious software, and any
              inappropriate material. Except as provided by applicable law, you are solely responsible for backing up
              and maintaining duplicate copies of any information you store or transfer through our Services.{' '}
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={6}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Services</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              We reserve the right in our sole and absolute discretion to change, suspend, or discontinue any aspect of
              the Services at any time and in any jurisdiction, including hours of operation or availability of any
              feature, without notice and without liability. We may advise you of any such changes, suspensions or
              discontinuations via your Retailer Account or the other contact details that you have provided to us, but
              shall have no obligation to do so.
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              If you do not agree with any change, suspension, or discontinuance of any aspect of the Services, then
              your sole and exclusive remedy is to terminate your use of the Services and close your Retailer Account.
              You agree that neither we nor any other Indemnified Party shall be liable to you or any third party for
              any Losses suffered as a result of any such changes, suspensions, discontinuations or decisions.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-0" start={4}>
          <li className="c7 c9 li-bullet-0">
            <h1 id="h.3rdcrjn" style={{ display: 'inline' }}>
              <span className="c3">Orders</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Acceptance</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-2">
            <span className="c0">
              Upon the creation of your Retailer Account, you will be able to submit orders for Brand Products.{' '}
            </span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">
              By obtaining a Retailer Account and using the Services, you agree that Brands may accept orders from you
              for the purchase of the products made available via the Services (each a “
            </span>
            <span className="c3">Product</span>
            <span className="c0">
              ”) and that such acceptance will result in the conclusion of a contract (each an “
            </span>
            <span className="c3">Order</span>
            <span className="c0">
              ”) for the sale of the relevant Product to you in accordance with these Retailer Terms and any applicable
              Brand Terms and Conditions.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={2}>
          <li className="c7 c9 li-bullet-0">
            <h2 id="h.26in1rg" style={{ display: 'inline' }}>
              <span className="c3">Order Minimums (Quantity and Value)</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Brands may set minimum order quantities for their Products (i.e. the minimum quantity of Product that a
              Retailer must order in each Order), which will be displayed on the Brand Page ("
            </span>
            <span className="c3">Minimum Order Quantity</span>
            <span className="c0">"). </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Brands may set minimum order values for their Products (i.e. the minimum value of Product that a Retailer
              must order in each Order), which will be displayed on the Brand Page ("
            </span>
            <span className="c3">Minimum Order Value</span>
            <span className="c0">
              "). You acknowledge that Markato may impose its own Minimum Order Values on Retailers, and that Market may
              restrict a Retailer from placing an order for Products which is less than Markato's Minimum Order Value
              (even where the order value is more than a Brand's Minimum Order Value).
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={3}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Right to Refuse</span>
            </h2>
          </li>
        </ol>
        <p className="c17">
          <span className="c0">
            You acknowledge and agree that Brands may refuse to complete your purchase (either at the &nbsp;time of
            submission of, &nbsp;or following the submission of, an Order) and Markato may cancel a purchase (i.e. the
            relevant Order) for any reason.
          </span>
        </p>
        <ol className="c1 lst-kix_list_1-1" start={4}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Inventory</span>
            </h2>
          </li>
        </ol>
        <p className="c17">
          <span className="c0">
            Markato will encourage Brands to have sufficient inventory to sell goods to Retailers. However, you
            acknowledge and agree that Markato does not guarantee a Brand's inventory or that there will be enough
            product to sell to you.
          </span>
        </p>
        <ol className="c1 lst-kix_list_1-1" start={5}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span>Samples</span>
            </h2>
          </li>
        </ol>
        <p className="c17">
          <span className="c0">Brands may, from time to time, inc</span>
          <span>lude samples in orders that are shipped to you.</span>
          <span className="c0">&nbsp;Any samples that you receive are made available on an</span>
          <span>“as is” basis, and</span>
          <span className="c0">
            &nbsp;are non- returnable and non-refundable. Markato will not be responsible for, and disclaimers any and
            al
          </span>
          <span>l </span>
          <span className="c0">liability incurred by you in relation to, </span>
          <span className="c0">any samples that you receive from a Brand.</span>
        </p>
        <ol className="c1 lst-kix_list_1-1" start={6}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">No Circumvention</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              You acknowledge and agree that you will place all orders for a Brand's product through the Services for
              any Brand that you are first introduced to through the Services.{' '}
            </span>
          </li>
          <li className="c2 li-bullet-1" id="h.lnxbz9">
            <span className="c0">
              You further agree to not influence Brands to, or otherwise circumvent Markato’s process, to transact
              offline outside of the Services in any manner.
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              You agree to not fulfil orders for Products on third party websites unless they are approved by Markato.{' '}
            </span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">
              Failure to comply with this provision may result in temporary suspension or permanent termination of your
              Retailer Account and your ability to purchase products on Markato in the future.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={7}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Shipping Address and Drop Shipping</span>
            </h2>
          </li>
        </ol>
        <p className="c17">
          <span className="c0">
            You agree to provide a valid, physical address to receive any product that you order through the Services.
            Markato does not offer drop shipping to customers of Retailers. Retailers are also not allowed to forward
            purchased products to overseas locations, whether through mail forwarding services or otherwise.
          </span>
        </p>
        <ol className="c1 lst-kix_list_1-1" start={8}>
          <li className="c7 c9 li-bullet-0">
            <h2 id="h.35nkun2" style={{ display: 'inline' }}>
              <span className="c3">Fraudulent Activity and Monitoring</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-2" id="h.1ksv4uv">
            <span className="c0">
              You acknowledge and agree that Markato shall be permitted to monitor transactions, activities and
              behaviours associated with your Retailer Account, including the volume any type of Orders entered into via
              your Retailer Account and the incidents of fraud (or attempted fraud), and disclose such information (and
              any other data, metrics or Retailer Information collected in connection with your Retailer Account or use
              of the Services), to any Intermediary Service Provider, credit reference and fraud prevention or financial
              crime agency, or Regulatory Authority, for the purposes of monitoring, investigating and taking action in
              relation to any fraudulent, criminal or illegal activity, non-compliance with applicable laws, or any
              breach of these Terms of Service.
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              You shall use your best endeavours to assist Markato (or any Intermediary Service Provider, credit
              reference and fraud prevention or financial crime agency, or Regulatory Authority) with any investigation
              that arises in relation to the Orders entered into via your Retailer Account.
            </span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">
              If you suspect that any Order involves fraudulent, criminal or illegal activity then you shall immediately
              notify Markato about this suspicion and, save where not reasonably practicable having regard to the safety
              and security of the Retailer, immediately cease to submit such Order.{' '}
            </span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">
              If Markato has reason to suspect that any transactions, activities or behaviours associated with your
              Retailer Account, including any Orders entered into via your Retailer Account involve fraudulent, criminal
              or illegal activity, non-compliance with applicable laws, or any breach of these Terms of Service, Markato
              may, in its absolute discretion, suspend or close your Retailer Account (or remove or block your
              acquisition of one or more Products), without notice and without liability.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={9}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Taxes</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              To the extent of transactions entered into by you with Brands via the Services, Markato will calculate the
              tax (generally, VAT or GST) payable, if applicable, and include this on the order invoice issued for or on
              behalf of the Brand.{' '}
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              You acknowledge that you are liable and required to pay to the Brand any taxes so calculated and agree to
              assume liability for payment for the full amount of the order invoice including any taxes calculated by
              Markato on behalf of the Brands. You hereby release Markato with respect thereto, and agree to indemnify,
              defend and hold Markato harmless against any and all such (withholding or other) taxes, contributions,
              penalties and/or interest.{' '}
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-0" start={5}>
          <li className="c7 c9 li-bullet-0">
            <h1 id="h.44sinio" style={{ display: 'inline' }}>
              <span className="c3">Product and Content Compliance</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c6 li-bullet-0">
            <span className="c0">Markato reserves the right to accept or reject any Products. </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              You acknowledge and agree that Brands are prohibited from selling or offering for sale (and that you will
              not procure or solicit the acquisition of), via the Services, any of the following products or services:
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">Drugs, Drug Proprietaries, Druggist Sundries</span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">Drug Stores, Pharmacies</span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">Direct Marketing – Travel-Related Arrangement Services</span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">Direct Marketing – Outbound Telemarketing Merchants</span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">Direct Marketing – Inbound Telemarketing Merchants</span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">Cigar Stores and Stands</span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">Dating and Escort Services</span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Betting, including Lottery Tickets, Casino Gaming Chips, Off-Track Betting, and Wagers at Race Tracks
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Computer Network/Information Services, for the sale of access to cyberlockers or remote digital
              file-sharing services
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Digital Goods – Games, for Transactions involving skilled game wagering (for example: daily fantasy
              sports)
            </span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">
              Non-Financial Institutions – Foreign Currency, Non-Fiat Currency [for example: Cryptocurrency], Money
              Orders [Not Money Transfer], Travelers Cheques, and Debt Repayment, for the sale of cryptocurrencies.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={3}>
          <li className="c6 li-bullet-0">
            <span className="c0">
              You acknowledge and agree that Markato is not required to determine whether the products sold on the
              Services, or any Content related thereto:
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-2">
            <span className="c0">
              abide by Markato’s Product Guidelines and/or are not prohibited under Markato’s Product Guidelines;
            </span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">
              comply with all laws, rules and regulations, including but not limited to, safety, labelling, testing,
              warning, import/export, and/or other consumer protection law requirements;{' '}
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              do not infringe upon the intellectual property rights, publicity or other rights of others;{' '}
            </span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">do not contain false, inaccurate or misleading information; </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">possess or compl</span>
            <span>y</span>
            <span className="c0">
              &nbsp;with necessary rights, licenses, permissions and consents for the offering of sale or sale of such
              Products through the Services;
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              are allowed to be sold from the Brand’s jurisdiction and/or into your jurisdiction; and/or{' '}
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              are allowed to be sold by you from your jurisdiction into your customer’s jurisdiction.{' '}
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={4}>
          <li className="c6 li-bullet-0">
            <span className="c0">
              You agree to conduct the necessary due diligence for compliance and suitability of Brands and their
              products and accept the legal implications of purchasing products sold on the Services, including but not
              limited to tax and duties, licensing and any customs formalities, duties or tariffs associated with
              international purchases.{' '}
            </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              You hereby release Markato from any liability with respect thereto, and agree to indemnify, defend and
              hold harmless Markato (and each other Indemnified Party) for any claims as set forth in the
              indemnification section below.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-0" start={6}>
          <li className="c7 c9 li-bullet-0">
            <h1 style={{ display: 'inline' }}>
              <span className="c3">Content License, Representations and Warranties</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">License from Markato</span>
            </h2>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">Limited License</span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Markato displays various Content related to the products, including photographs, product descriptions,
              Brand stories and any other related content for sale on its Services. You are granted a limited,
              royalty-free, non-assignable, non- sublicensable and revocable license to use Content related to a product
              that you purchase on the Services on your own company’s website for the sole purpose of reselling that
              same product. Notwithstanding the foregoing, you agree that you will not use any such Content in any ad or
              media campaign, including postings, emails, ads or any other communication, without the express written
              consent from the owner of that Content.
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              You acknowledge and agree that you are merely a licensee of the Content and that you do not own, and will
              not claim any ownership rights in, the Content. You further acknowledge and agree that Markato is not
              responsible, nor shall Markato be held liable, for any Content, and Markato makes no representation or
              warranty that the Content does not infringe, misappropriate or violate a third party’s patent, copyright,
              trademark, trade secret, moral rights or other intellectual property rights, or rights of publicity or
              privacy, or contain libellous or otherwise unlawful, abusive, harassing or obscene material, or result in
              the violation of any applicable law or regulation.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={3}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">License from Retailer</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              In connection with your use of the Services, you hereby grant to Markato and its Affiliates a worldwide,
              perpetual, non-exclusive, transferable, sublicensable, royalty-free license to use, view, copy, adapt,
              modify, distribute, publicly display and publicly perform (through any means necessary) and Marks, Content
              or &nbsp;information that you provide to Markato ("
            </span>
            <span className="c18">Y</span>
            <span className="c3">our Retailer Materials</span>
            <span className="c0">
              ") in connection with your Retailer Account, in each case for the purposes of providing you with the
              Services.{' '}
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Markato does not claim any ownership rights in any of Your Retailer Materials and nothing in these
              Retailer Terms will be deemed to restrict any rights that you may have to use and exploit Your Retailer
              Materials.{' '}
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              You hereby agree that Markato may, at its option, grant a limited, royalty-free, revocable sublicense to
              our third party service providers, solely for the purpose of enabling such service providers to provide
              services to us &nbsp;(and not for any commercialisation purposes).
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={4}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Representations and Warranties </span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              You acknowledge and agree that you are solely responsible for Your Retailer Materials that you make
              available to us. Accordingly, you represent and warrant that:
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-3 start" start={1}>
          <li className="c10 li-bullet-0">
            <span className="c0">
              you are either the sole and exclusive owner of Your Retailer Materials that you make available to us or
              you have all rights, licenses, consents and releases necessary to grant to Markato the rights in Your
              Retailer Materials as contemplated under these Retailer Terms;
            </span>
          </li>
          <li className="c10 li-bullet-0">
            <span className="c0">
              neither Your Retailer Materials nor your posting, uploading, publication, submission or transmittal of
              Your Retailer Materials or the use by Markato or any of its permitted sub-licensees of Your Retailer
              Materials (or any portion thereof) on, through or by means of the Services or social media platforms will
              infringe, misappropriate or violate any rights (including intellectual property rights) of a third party,
              or contain inaccurate, misleading, libellous, misleading or otherwise unlawful, abusive, harassing or
              obscene material, or contain any computer virus or other malware that could in any way affect the
              operation of the Services, or result in the violation of any applicable law or regulation; and
            </span>
          </li>
          <li className="c10 li-bullet-0">
            <span className="c0">
              you will not use a false e-mail address, pretend to be someone other than yourself or otherwise mislead us
              or third parties as to the origin of any posts. You are solely responsible for Your Retailer Materials you
              provide and its accuracy. Markato takes no responsibility and assumes no liability, and you hereby release
              Markato from any such liability related to Your Retailer Materials posted or otherwise made available by
              you, and you agree to indemnify Markato
            </span>
            <span className="c3">&nbsp;</span>
            <span className="c0">
              (and each other Indemnified Party) per the terms of the Indemnification section herein.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={5}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Feedback</span>
            </h2>
          </li>
        </ol>
        <p className="c17">
          <span className="c0">
            You acknowledge and agree that any materials, including without limitation questions, comments, feedback,
            suggestions, ideas, plans, notes, drawings, original or creative materials or other information or
            commentary regarding the Services (collectively,{' '}
          </span>
          <span className="c3">"Feedback"</span>
          <span className="c0">
            ) that are provided by you, whether by email, posting to the Site or social channels, or otherwise, are
            non-confidential and that Markato will be entitled to the unrestricted use and dissemination of such
            Feedback for any purpose, commercial or otherwise, without acknowledgment or compensation to you.
          </span>
        </p>
        <ol className="c1 lst-kix_list_1-0" start={7}>
          <li className="c7 c9 li-bullet-0">
            <h1 id="h.2jxsxqh" style={{ display: 'inline' }}>
              <span className="c3">Payment</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Payment Methods </span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span>
              You may purchase Products via the Services using the approved payment methods made available to you via
              the Services in the relevant territory. These payment methods may include:
            </span>
            <span>(i)</span>
            <span className="c0">
              &nbsp;a credit or debit card; (ii) a bank transfer; or (iii) such other methods as are made available to
              you via the Services.. In order{' '}
            </span>
            <span>t</span>
            <span className="c0">o </span>
            <span>
              use a particular payment method you must provide the payment information requested via the Services.
            </span>
            <span className="c0">&nbsp;Approved payment methods may vary by region.</span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              By submitting payment details, in conjunction with registering for a Retailer Account and/or purchasing
              goods, you agree to pay for the goods purchased, and any applicable taxes and other fees that may accrue
              in relation to the purchase of such goods, and you authorize each relevant Brand, Markato, each of their
              respective affiliates and any payment processor for any of them to charge the payment method with any
              payment due from you using the information you have supplied to Markato, and/or (where applicable) to
              credit that payment method and/or to make any adjustments if necessary.{' '}
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">Markato reserves the right to correct any errors in pricing. </span>
          </li>
          <li className="c2 li-bullet-1">
            <span>
              If you elect to settle the amounts that you owe in respect of an order on a Buy Now Pay Later basis, then
              we may require you to provide us with details of a “default payment method”.
            </span>
            <span className="c0">The default payment method on file in your Retailer Account </span>
            <span>shall be</span>
            <span className="c0">&nbsp;charged for amounts due from you for</span>
            <span>&nbsp;your outstanding Buy Now Pay Later amount</span>
            <span className="c0">
              . If this fails, any other payment method you have included in your Retailer Account may be charged.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={2}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Payment Processors</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              You acknowledge that from time to time Markato may enter into arrangements with one or more payment
              processors for the purpose of facilitating payments of the Purchase Price in respect of the Orders ("
            </span>
            <span className="c3">Payment Processor Arrangement</span>
            <span className="c0">").</span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Where Markato enters into a Payments Processor Arrangement, it shall notify you of such additional terms
              (if any) that may apply to the facilitation of payments of the Purchase Price in respect of the Orders,
              and you acknowledge and agree to comply with such terms (and that such terms shall apply to the
              facilitation of payments of the Purchase Price in respect of the Orders).
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              As at the date of these Retailer Terms, Markato has entered into an arrangement with the payment processor
              [Airwallex] (the “
            </span>
            <span className="c3">Airwallex</span>
            <span className="c0">
              ”) to enable Airwallex to facilitate payments of the Purchase Price in respect of your Orders ("
            </span>
            <span className="c3">Airwallex Payment Processor Arrangement</span>
            <span className="c0">").</span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">
              Airwallex will facilitate payments for Orders by acting on the behalf of Brands in relation to the
              acquiring and collection of payments of the Purchase Price from Retailers and the making of applicable
              payments to Brands. [For this purpose, you are required to enter into and comply with certain terms of
              Airwalle
            </span>
            <span className="c0">x</span>

            <span className="c0">&nbsp;(the “</span>
            <span className="c3">Airwallex Terms</span>
            <span className="c0">
              ”), and by accepting these Retailer Terms you agree to be bound by the Airwallex Terms. The Airwallex
              Terms can be found here:
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-3 start" start={1}>
          <li className="c10 li-bullet-0">
            <span className="c0">https://www.airwallex.com/hk/terms/payout-and-fx;</span>
          </li>
          <li className="c10 li-bullet-0">
            <span className="c0">https://www.airwallex.com/hk/terms/merchant-scale-terms; and</span>
          </li>
          <li className="c10 li-bullet-0">
            <span className="c0">such other Airwallex terms referred to or linked to the above terms,</span>
          </li>
        </ol>
        <p className="c15">
          <span className="c0">
            in each case currently in force. To the extent of any inconsistency between this Paragraph 7 and the
            Airwallex Terms, the Airwallex Terms shall prevail.
          </span>
        </p>
        <ol className="c1 lst-kix_list_1-2" start={5}>
          <li className="c2 li-bullet-2">
            <span className="c0">
              You acknowledge that Airwallex shall not be obliged to enter into an agreement with you, if to do so would
              be inconsistent with Airwallex's policies, processes or applicable law. In this case, we shall endeavour
              to inform you where Airwallex does not agree to enter into an agreement with you, unless prohibited from
              telling you under applicable law. In this case, or where Airwallex suspends or{' '}
            </span>
            <span>terminates</span>
            <span className="c0">
              &nbsp;all or part of your access to its payments processing services, we shall have the right to suspend
              or close your Brand Account in our sole and absolute discretion, without notice and without liability.
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              You acknowledge that, for the duration of the Airwallex Payment Processor Arrangement:
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-3 start" start={1}>
          <li className="c14 li-bullet-0">
            <h4 style={{ display: 'inline' }}>
              <span className="c0">
                no payment services that are regulated under Applicable Laws are provided by Markato and that all such
                payment services are provided by Airwallex;
              </span>
            </h4>
          </li>
          <li className="c14 li-bullet-0">
            <h4 style={{ display: 'inline' }}>
              <span className="c0">
                Markato is designated as each Brand's authorised representative for the purposes of giving instructions
                to Airwallex, on behalf of each Brand, in relation to the collection of the Purchase Price of each Order
                from the Retailer and the payment of amounts due to the Brand in respect of &nbsp;each Order to each
                Brand (including in relation to advising the Airwallex of the amount and timing of to apply to each such
                payment);
              </span>
            </h4>
          </li>
          <li className="c14 li-bullet-0">
            <h4 style={{ display: 'inline' }}>
              <span className="c0">
                Airwallex shall share Brand and Retailer account data (where applicable) with Markato for the purpose of
                enabling Markato to make payments to Brands in respect of Orders (and you consent to the sharing of such
                data);{' '}
              </span>
            </h4>
          </li>
          <li className="c14 li-bullet-0">
            <h4 style={{ display: 'inline' }}>
              <span className="c0">
                Markato shall be entitled to instruct Airwallex to pay to Markato the amount of any fees or commissions
                payable by Brands to Markato by way of deduction from any amount at any time being held by Airwallex for
                a Brand; and
              </span>
            </h4>
          </li>
          <li className="c14 li-bullet-0">
            <h4 style={{ display: 'inline' }}>
              <span className="c0">
                the services provided by Airwallex in relation to the facilitation of payments to Brands in respect of
                Orders are separate and distinct from the Services provided by Markato.
              </span>
            </h4>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2" start={7}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Without limit to the other consents and authorisations provided in these Retailer Terms, you authorise
              Markato to:
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-3 start" start={1}>
          <li className="c14 li-bullet-0">
            <h4 style={{ display: 'inline' }}>
              <span className="c0">perform the Services; and</span>
            </h4>
          </li>
          <li className="c14 li-bullet-0">
            <h4 style={{ display: 'inline' }}>
              <span className="c0">
                provide Settlement Data to Airwallex for the allocation by Airwallex of funds received from Acquirers to
                the Global Accounts of you (and other Retailers) in accordance with such Settlement Data.{' '}
              </span>
            </h4>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={3}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Conclusion of Order Contracts </span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              In relation to the conclusion through the Markato platform of any contract for the purchase of goods by
              you from a Brand (a “
            </span>
            <span className="c3">Contract</span>
            <span className="c0">
              ”), Markato is appointed and authorised by the Brand to process such orders and provide certain services
              on Brand’s behalf.{' '}
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Accordingly, where payment of any amount payable by you to a Brand in respect of any Contract with that
              Brand is made to Markato, this shall discharge your obligation to the Brand to the extent of the amount so
              paid. Markato does not act as agent for you in relation to the negotiation or conclusion of, or any
              payment made under, any Contract.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={4}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Payment timings / Buy Now Pay Later Timing</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              In respect of payments by you to Brands in respect of Contracts, Markato is granted a discretion by the
              Brands to determine which of two payment timings shall be available to you in respect of the purchase
              price under such Contracts (the “
            </span>
            <span className="c3">Purchase Price</span>
            <span className="c0">”), these being:</span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-3 start" start={1}>
          <li className="c10 li-bullet-0">
            <span className="c0">
              Payment on Order check-out confirmation: the Retailer is obliged to make payment of the Purchase Price at
              the time at which they{' '}
            </span>
            <span>place</span>
            <span className="c0">&nbsp;the Order via the Services (the </span>
            <span className="c3">“Check-out confirmation Date</span>
            <span className="c0">”); or</span>
          </li>
          <li className="c10 li-bullet-0">
            <span className="c0">60-day terms</span>
            <span>&nbsp;(also known as 60-day Buy Now Pay Later terms)</span>
            <span className="c0">
              : the Retailer is granted a period of interest-free trade credit as a consequence of which the Retailer is
              obliged to make payment of the Purchase Price on the day falling 60 days after the Check-out confirmation
              Date ("
            </span>
            <span className="c3">Buy Now</span>
            <span className="c18">&nbsp;</span>
            <span className="c3">Pay Later"</span>
            <span className="c0">). </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2" start={2}>
          <li className="c2 li-bullet-1">
            <span className="c0">In determining whether to make Buy Now</span>
            <span>&nbsp;</span>
            <span className="c0">
              Pay Later payment timing available to you in respect of any Contract, Markato will consider your credit
              standing and the aggregate amount outstanding from you in respect of all other Contracts under which
              payment has not yet been made in full (the “
            </span>
            <span className="c3">Outstanding Credit Amount</span>
            <span className="c0">”). </span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">Markato may in its discretion set a credit limit (the “</span>
            <span className="c3">Credit Limit</span>
            <span className="c0">
              ”) which shall apply to all your Contracts such that, although you will generally be approved by Markato
              for the provision of{' '}
            </span>
            <span>Buy Now Pay Later</span>
            <span className="c0">&nbsp;payment &nbsp;timing, if the extension of such Buy Now</span>
            <span>&nbsp;</span>
            <span className="c0">
              Pay Later payment timing to any new Contract will cause the Outstanding Credit Amount to exceed such
              Credit Limit, payment on Check-out confirmation Date shall be applied to that Contract. However, you shall
              have the option to avoid this consequence by logging onto your Retailer Account and paying down amounts
              outstanding under other Contracts to reduce the Outstanding Credit Amount by the requisite amount. Markato
              reserves the right to change any Credit Limit from time to time in its entire discretion and you may
              request an increase to your Credit Limit through your Retailer Account.{' '}
            </span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">
              Markato may also apply a maximum Contract purchase price size for Contracts to which Buy Now
            </span>
            <span>&nbsp;</span>
            <span className="c0">
              Pay Later payment timing may be applied. You agree that you will not create multiple accounts in an
              attempt to circumvent spending limits.
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Markato shall arrange for you to be provided with an invoice for the amounts payable in respect of an
              Order (including the Purchase Price and Shipping Costs).{' '}
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={5}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Failure to Make Payment</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              You acknowledge and agree that if you fail to make payment when due of any part of the Outstanding Credit
              Amount or any other amount owing under these Terms, Markato may:
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-3 start" start={1}>
          <li className="c10 li-bullet-0">
            <span className="c0">
              on behalf of the parties to whom the Outstanding Credit Amount is then owed, give notice making the whole
              of the Outstanding Credit Amount and any other amount payable by you under these Terms due and payable
              immediately (if not so already);
            </span>
          </li>
          <li className="c10 li-bullet-0">
            <span className="c0">on behalf of the relevant Brands, cancel or suspend any Contracts;</span>
          </li>
          <li className="c10 li-bullet-0">
            <span className="c0">temporarily suspend or permanently terminate your Retailer Account;</span>
          </li>
          <li className="c10 li-bullet-0">
            <span className="c0">reduce any Credit Limit to zero;</span>
          </li>
          <li className="c10 li-bullet-0">
            <span className="c0">
              apply any amount in Markato’s possession or control which is owed to you toward reduction of the
              Outstanding Credit Amount; and/or
            </span>
          </li>
          <li className="c10 li-bullet-0">
            <span className="c0">
              assess an additional fee in respect of collection and related services which shall be calculated by
              applying interest&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;on any amount outstanding from you at the
              rate of{' '}
            </span>
            <span className="c0">8% per annum</span>
            <span className="c0">&nbsp;from the due date of such amount to its date of payment.</span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2" start={2}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Markato reserves the right in these circumstances, acting on behalf of the relevant creditor, to turn over
              the collection of any amount due from you to a collection agency or seek any other legal or equitable
              remedies available to collect any outstanding debt.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={6}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Indemnity to Markato</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              You acknowledge that, if you fail to make payment when due of any part of the Outstanding Credit Amount or
              other amount owing under these Terms, Markato may, as a matter of good platform management, make payment
              of the amount due to the relevant creditor (the “
            </span>
            <span className="c3">Discharged Creditor</span>
            <span className="c0">
              ”). You acknowledge and agree that to the extent that Markato does this, you shall be liable to Markato in
              the same amount and to the same extent as you were liable to the Discharged Creditor and you shall
              indemnify Markato (and each other Indemnified Party) against any costs, detriment, damage or losses which
              it suffers as a consequence of your non-payment of any part of the Outstanding Credit Amount or other
              amount owing under these Terms when due.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-0" start={8}>
          <li className="c7 li-bullet-0">
            <h1 id="h.z337ya" style={{ display: 'inline' }}>
              <span className="c3">Shipping, Costs, Lead Times, Shipping Providers, Damaged Products</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c7 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Shipping</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Markato shall make available to Retailers the option to select an appropriate shipping method for
              Products. Once a Retailer has selected the appropriate shipping method, Markato will be responsible for
              engaging a shipping provider, and procuring the shipping provider to collect the Products from the pick-up
              location notified to us during the registration of the Brand Account (or otherwise notified to us using
              the Services). Details of this shipping provider will be provided to you prior to the collection of the
              Products.{' '}
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">You acknowledge that each Brand:</span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-3 start" start={1}>
          <li className="c10 li-bullet-0">
            <span className="c0">
              shall be responsible for packaging its Products that are the subject of an Order to the relevant Retailer,
              in accordance with the details specified in the relevant Order.
            </span>
          </li>
          <li className="c10 li-bullet-0">
            <span className="c0">
              shall ensure that its Products, and all packaging of its Products, complies with: (i) applicable laws,
              including safety, packaging, labelling, warning, import/export, tax and other consumer protection laws;
              and (ii) the terms and conditions of the relevant shipping provider. You acknowledge and agree that
              Markato will not be responsible, and disclaimers any and all liability, for any failure by a Brand's
              Products or any packaging of its &nbsp;Products to comply with (i) applicable laws, including safety,
              packaging, labelling, warning, import/export, tax and other consumer protection laws; and (ii) the terms
              and conditions of the relevant shipping provider.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2" start={3}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              You acknowledge that lead times vary on how long it takes for a Brand to ship a product. Average lead
              times are displayed on the Brand's page and/or when the product is in your cart.{' '}
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Once the Brand accepts the order, the expected ship date will be updated in your Retailer Account. You
              will receive a notice once the product has shipped, giving you a tracking number and letting you know the
              cost of shipping. This information is also available in your Retailer Account.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={2}>
          <li className="c7 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Shipping Costs</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-2">
            <span className="c0">
              At the time that the Retailer places an order for the purchaser of goods and selects an appropriate
              shipping method the Retailer shall be notified of the applicable shipping costs ("
            </span>
            <span className="c3">Shipping Costs"</span>
            <span className="c0">
              ). Unless Markato has authorized free shipping, you are responsible for and agree to pay for all shipping
              costs displayed on your invoice as well as any customs and/or duties on international orders. Shipping
              costs will be included in your invoice. Shipping costs will vary depending on the weight of the package
              and where the package is being shipped from.
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              You acknowledge that Markato may choose to invoice Retailers for the Shipping Costs, and that where it
              does so Markato shall retain all amounts paid by the Retailers in respect of such Shipping Costs (and that
              these amounts are separate from the &nbsp;Purchase Price paid for the Products).
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Shipping Costs may appear on a Retailer’s invoice, and shall reflect the actual shipping costs incurred to
              ship the Products.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={3}>
          <li className="c7 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span>Tracking Number</span>
            </h2>
          </li>
        </ol>
        <p className="c17">
          <span className="c0">
            Upon the acceptance of any Order, Markato shall arrange for a tracking number to be issue
          </span>
          <span>d to you,</span>
          <span className="c0">
            &nbsp;which may be used for tracking the status of such Order (including packaging, shipment and delivery
            details).{' '}
          </span>
          <span className="c0">
            You acknowledge that each shipping provider engaged to ship your Orders (and not Markato) shall be
            responsible for preparing each tracking number
          </span>
          <span>
            , and for keeping the information regarding the status of your Order that is linked to the tracking number
            uptodate and accurate.
          </span>
        </p>
        <ol className="c1 lst-kix_list_1-1" start={4}>
          <li className="c7 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Shipping Insurance</span>
            </h2>
          </li>
        </ol>
        <p className="c17">
          <span className="c0">
            Markato does not require you to purchase shipping insurance. However, Markato strongly recommends that you
            do so in order to facilitate any shipping dispute you have with a Brand.
          </span>
        </p>
        <ol className="c1 lst-kix_list_1-0" start={9}>
          <li className="c7 c9 li-bullet-0">
            <h1 id="h.3j2qqm3" style={{ display: 'inline' }}>
              <span className="c3">Returns, Refunds, Cancellations</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Returns</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-2">
            <span className="c0">
              Markato offers each Retailer the right to freely return (and, where applicable, collect a refund for) the
              Products specified in the first Order submitted by the Retailer to a Brand.{' '}
            </span>
            <span>
              To be eligible to return and collect a refund for such Products you must notify us of your intention to
              return the relevant Products within the time period specified on the Site (
            </span>
            <span className="c18">“Return Eligibility Period</span>
            <span>
              ”) and comply with such other guidance set out on the Site regarding returns, refunds and cancellations (“
            </span>
            <span className="c18">Returns, Refunds and Cancellations Policy</span>
            <span>
              ”). You may notify us of your intention to return a Product using the functionality provided in the
              Services and, where you have complied with the relevant terms, Markato will fund a
            </span>
            <span>&nbsp;full refund </span>
            <span>
              of the paid value of the Products (excluding shipping costs, and discounts applied, or and VAT/GST which
              may apply) in the form of "Markato Wallet Credits" for any qualifying Product.
            </span>
            <span>&nbsp;</span>
            <span className="c0">
              This right shall not apply to second and subsequent Orders between a Retailer and Brand. &nbsp;
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Markato, not the Brand, takes on this return risk. Markato reserves the right to make available such
              return/refund services to Retailers in the manner and form, and subject &nbsp;to &nbsp;the condition,
              determined by Markato in its discretion. For example, refunds for returned Products may be made available
              in the form of "Markato Wallet Credits", to be spent by the Retailer via the Services, rather than cash
              refunds, and the availability of such return/refund rights may &nbsp;be subject to maximum refund values.
            </span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">
              Markato may at its discretion take title to all Products returned by a Retailer, subject to its return
              policies (not all Products are eligible for return).{' '}
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Markato may, at its discretion, require you to ship the returned order to a specified location
            </span>
            <span className="c0">, in which case Markato will cover the associated shipping costs. </span>
            <span className="c0">
              When goods are returned to Markato by a Retailer, Markato may at its option redistribute those products
              through its various redistribution channels.{' '}
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              To qualify for free returns and prevent future charges, you must adhere to Markato return policies as
              outlined in our{' '}
            </span>
            <span className="c0">Returns, Refunds and Cancellations Policy. </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              You acknowledge and agree that any orders from a Brand not covered in Markato’s Returns, Refunds and
              Cancellations Policy are not eligible for return, except under certain limited circumstances described
              therein.{' '}
            </span>
            <span>Y</span>
            <span className="c0">
              ou acknowledge and agree that you shall pay for all shipping costs to your retail store
            </span>
            <span>, and those</span>
            <span className="c0">
              &nbsp;shipping costs are non-refundable, even if you later return the relevant Pro
            </span>
            <span>ducts</span>
            <span className="c0">&nbsp;for free under this Paragraph.</span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={2}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Refunds and cancellations</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Retailers may contact us via the Services if they have any issues relating to damaged or missing items in
              an order. Markato will notify the relevant Brand if a Retailer reports to Markato that a Product is
              damaged or if an order is missing items. Markato will pass along any photographs of any damaged item or of
              the order as a whole that it receives.{' '}
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              If you receive a product that is damaged, the shipment includes missing items or you do not receive the
              product by the expected ship date, you must report the issue within{' '}
            </span>
            <span>7</span>
            <span className="c0">
              &nbsp;days of receiving the product as outlined in our Returns, Refunds and Cancellations Policy. Y
            </span>
            <span className="c0">
              ou agree that if you do not timely report the issue, the product shall be deemed delivered and
              satisfactory.
            </span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">
              Markato reserves the right to accept or reject any missing or damaged report filed by a Retailer in its
              sole reasonable discretion, including in the event Markato suspects any fraudulent activity. Markato’s
              decision whether to accept a damaged or missing claim shall be final.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-0" start={10}>
          <li className="c7 li-bullet-0">
            <h1 style={{ display: 'inline' }}>
              <span className="c3">Commitment to Quality and Service</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c7 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Minimum Standards</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Brand and Retailer satisfaction is of utmost importance to the long-term health and success of the Markato
              community.{' '}
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Accordingly, Brands are subject to the following minimum standards in connection with the Services:
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-3 start" start={1}>
          <li className="c14 li-bullet-0">
            <h4 style={{ display: 'inline' }}>
              <span className="c0">to accurately list and describe available Products on Brand Pages;</span>
            </h4>
          </li>
          <li className="c14 li-bullet-0">
            <h4 style={{ display: 'inline' }}>
              <span className="c0">to ensure that any cancellation of an Order is effected in a timely manner;</span>
            </h4>
          </li>
          <li className="c14 li-bullet-0">
            <h4 style={{ display: 'inline' }}>
              <span className="c0">
                to timely package and prepare for shipment Products that are the subject of an Order (in accordance with
                the specifications of the Order);
              </span>
            </h4>
          </li>
          <li className="c14 li-bullet-0">
            <h4 style={{ display: 'inline' }}>
              <span className="c0">to promptly and effectively respond to Retailer inquiries; and</span>
            </h4>
          </li>
          <li className="c14 li-bullet-0">
            <h4 style={{ display: 'inline' }}>
              <span className="c0">to promptly resolve missing or damaged orders with a Retailer.</span>
            </h4>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2" start={3}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Please notify Markato if you have any concerns with a Brand's compliance with any of the foregoing.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={2}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Metrics</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Markato will track and measure your use of the Services using a variety of metrics, including collecting
              reviews and ratings from your Brands. Reviewed individually and as a whole, these metrics help Markato
              determine whether you are meeting Markato’s expectations on delivering a great experience for the Brands.{' '}
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">Such metrics may include:</span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-3 start" start={1}>
          <li className="c10 li-bullet-0">
            <span className="c0">your timely payment for Orders;</span>
          </li>
          <li className="c10 li-bullet-0">
            <span className="c0">how often your orders are reported as damaged or missing Products:</span>
          </li>
          <li className="c10 li-bullet-0">
            <span className="c0">how often your Orders are returned or cancelled; and</span>
          </li>
          <li className="c10 li-bullet-0">
            <span className="c0">how promptly and effectively you respond to Brand inquiries.</span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={3}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Volume Considerations</span>
            </h2>
          </li>
        </ol>
        <p className="c17">
          <span className="c0">Markato takes volume consideration into account when calculating metrics.</span>
        </p>
        <ol className="c1 lst-kix_list_1-1" start={4}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Evaluation</span>
            </h2>
          </li>
        </ol>
        <p className="c17">
          <span className="c0">
            Markato typically evaluates a Retailer's performance using the above metrics on an ongoing monthly basis,
            and more frequently during high volume periods such as the holiday selling season. The length of time
            between reviews depends on the volume of transactions of each flagged Retailer Account and/or the extent of
            available data. Markato reserves the right to adjust its evaluation criteria as needed.
          </span>
        </p>
        <ol className="c1 lst-kix_list_1-1" start={5}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Accountability</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              If Markato determines that you are not meeting the minimum standards, Markato may reach out to you in an
              attempt to resolve the issue and/or temporarily suspend or permanently terminate your Retailer Account.{' '}
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">Markato also reserves the right to put limits on your Retailer Account.</span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={6}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Suspended Accounts</span>
            </h2>
          </li>
        </ol>
        <p className="c17">
          <span className="c0">
            If your Retailer Account is suspended for performance issues, you may appeal for re-activation by providing
            Markato with a plan of action for correcting the problems that contributed to the account being flagged and
            suspended. If Markato in its sole discretion approves the plan of action, you may resume acquiring through
            the Services. If you believe that the flag on your Retailer Account is erroneous, you may contact Markato
            and explain why.
          </span>
        </p>
        <ol className="c1 lst-kix_list_1-0" start={11}>
          <li className="c7 li-bullet-0">
            <h1 id="h.4i7ojhp" style={{ display: 'inline' }}>
              <span className="c3">Product Liability Insurance</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c6 li-bullet-0">
            <span className="c0">All Retailers are </span>
            <span>encouraged</span>
            <span className="c0">
              &nbsp;to maintain, at their own cost and expense, general commercial liability insurance (including
              comprehensive product liability) with respect to the Products acquired via the Services in such amount as
              is reasonable and customary for companies of comparable size and activities. Markato reserves the right to
              request proof of such insurance coverage and other relevant information at any time.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-0" start={12}>
          <li className="c7 li-bullet-0">
            <h1 style={{ display: 'inline' }}>
              <span className="c3">your general obligations</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c7 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c0">You agree that you shall not use the Site, Application or Services to:</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              publish or disseminate any material that is: (i) unlawful, threatening, defamatory, obscene, infringing,
              harassing or racially or ethnically offensive, facilitates illegal activity, depicts sexually explicit
              images or promotes unlawful violence, or involves discrimination based on race, gender, colour, religious
              belief, sexual orientation or disability; or (ii) in the opinion of Markato is harmful or inappropriate.{' '}
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              send computer viruses, worms, Trojan horses, logic bombs or any other malicious program, file, or any
              other form of malware, intended to damage, interrupt, suspend, destroy and/or restrict the functionalities
              of any IT or telecommunication equipment;
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              carry out commercial or advertising activities of any kind (notably the sending of unsolicited promotional
              messages, contests, lotteries, exchanges), or solicit payments or online donations;
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              access, use or attempt to use another user's User Credentials and Security Passwords;
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">attempt to access all or part of the Service without authorisation;</span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              use data mining tools, bots or any other similar tools for collecting and extracting data from the Site,
              Application or Services;
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">hinder the operation of the Site, Application or Services and/or the Service;</span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">
              take any action that would be likely to result in Markato being held liable, or in losing the benefit of
              all or part of the services of Markato’s partners and services providers, notably its Internet service
              providers, payment services providers, financing partners/and or storage partners; or
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              do anything that would be likely to harm the image and/or reputation of Markato or the Site, Application
              or Services.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-0" start={13}>
          <li className="c7 c9 li-bullet-0">
            <h1 id="h.2xcytpi" style={{ display: 'inline' }}>
              <span className="c3">Indemnity</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c6 li-bullet-0">
            <span className="c0">
              You agree to defend, indemnify, and hold harmless Markato and its Affiliates, and each of their respective
              Representatives ("
            </span>
            <span className="c3">Indemnified Parties</span>
            <span className="c0">
              "), from and against any and all Losses brought against, suffered or incurred by an Indemnified Party due
              to or arising out of or in connection with:
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-2">
            <span className="c0">any breach by you of the Terms of Service (including these Retailer Terms); and</span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">any breach by you of applicable laws,</span>
          </li>
        </ol>
        <p className="c17 c23">
          <span className="c0">(each, a "</span>
          <span className="c3">Claim</span>
          <span className="c0">").</span>
        </p>
        <ol className="c1 lst-kix_list_1-1" start={2}>
          <li className="c7 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c0">Subject to &nbsp;13.3, the Indemnified Party shall:</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c5 li-bullet-1">
            <h3 style={{ display: 'inline' }}>
              <span className="c0">promptly notify you in writing of any Claim that arises; and</span>
            </h3>
          </li>
          <li className="c5 li-bullet-2">
            <h3 style={{ display: 'inline' }}>
              <span className="c0">
                provide you, at your cost, with all assistance as it may reasonably require in relation to the conduct
                of such Claim.
              </span>
            </h3>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={3}>
          <li className="c7 li-bullet-0">
            <h2 id="h.1ci93xb" style={{ display: 'inline' }}>
              <span className="c0">
                An Indemnified Party may take any action to defend a Claim which it considers to be reasonably necessary
                if you unreasonably refuses to take action or unreasonably delays in taking action in defending or
                settling any such Claim. You shall be liable for, and shall indemnify and hold harmless the Indemnified
                Party from and against, all Losses incurred by the Indemnified Party in relation to taking such action.
              </span>
            </h2>
          </li>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c0">
                Markato holds the benefit of the indemnities under this Paragraph 15 (and each other indemnity provided
                by you under the Retailer Terms) for itself and on trust for each other Indemnified Party, in order to
                ensure that Markato may recover on behalf of each other Indemnified Party.
              </span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-0" start={14}>
          <li className="c7 c9 li-bullet-0">
            <h1 id="h.3whwml4" style={{ display: 'inline' }}>
              <span className="c3">LiabilitY and DISCLAIMERS</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c6 li-bullet-0" id="h.2bn6wsx">
            <span className="c0">
              The limitations on liability set out in these Retailer Terms do not apply in respect of any liability:
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c5 li-bullet-1">
            <h3 style={{ display: 'inline' }}>
              <span className="c0">for death or personal injury resulting from negligence;</span>
            </h3>
          </li>
          <li className="c5 li-bullet-1">
            <h3 style={{ display: 'inline' }}>
              <span className="c0">for fraud or fraudulent misrepresentation;</span>
            </h3>
          </li>
          <li className="c5 li-bullet-1">
            <h3 style={{ display: 'inline' }}>
              <span className="c0">for wilful default of these Retailer Terms; or</span>
            </h3>
          </li>
          <li className="c5 li-bullet-1">
            <h3 style={{ display: 'inline' }}>
              <span className="c0">that cannot be excluded by law.</span>
            </h3>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={2}>
          <li className="c6 li-bullet-0">
            <span className="c0">
              You acknowledge and agree that, to the maximum extent permitted by law, the entire risk arising out of
              your access to and use of the Services remains with you. Subject to Paragraph 1
            </span>
            <span>4</span>
            <span className="c0">
              .1, neither Markato nor any of its Affiliates (or any of their respective Representatives) shall be liable
              to you in contract, tort (including negligence), equity, statute or any other cause arising out of or in
              connection with the Retailer Terms for your use of the Services, including any liability that may arise in
              connection with any Service interruption, computer damage or system failure, the cost of substitute
              products or services, or from any communications, interactions or meetings with other users of the
              Services or other persons with whom you communicate or interact as a result of your use of the Services.
            </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">Subject to Paragraph 1</span>
            <span>4</span>
            <span className="c0">
              .1, you acknowledge and agree that the Services are provided on an "as is" basis, without any warranty or
              representation of any kind and, to the maximum extent permitted by applicable law, Markato and its
              Affiliates (and each of their respective Representatives) expressly disclaim any warranties or conditions,
              express, implied, statutory or otherwise, with respect to the Services, including, without limitation, any
              implied warranties of title, merchantability, fitness for a particular purpose or non-infringement. In
              particular, neither Markato nor its Affiliates (or any of their respective Representatives), makes any
              warranty that:
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              the Services (or any products, information, or other materials obtained by you in connection with the
              Services) will meet your requirements or expectations; or
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">the Services will be uninterrupted, timely, secure, or error-free.</span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={4}>
          <li className="c6 li-bullet-0" id="h.qsh70q">
            <span className="c0">Subject to Paragraph 1</span>
            <span>4</span>
            <span className="c0">
              .1, neither Markato nor any of its Affiliates (or any of their respective Representatives) shall be liable
              to you in contract, tort (including negligence), equity, statute or any other cause arising out of or in
              connection with the Retailer Terms for:{' '}
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c5 c9 li-bullet-1">
            <h3 style={{ display: 'inline' }}>
              <span className="c0">loss or corruption of data or information (whether direct or indirect);</span>
            </h3>
          </li>
          <li className="c5 c9 li-bullet-1">
            <h3 style={{ display: 'inline' }}>
              <span className="c0">
                loss of profits; loss of revenue; loss of goodwill; loss of use; loss of business or contract; loss of
                opportunity; increased costs or expenses; loss of savings; ex gratia payments or any other liability
                voluntarily assumed; or wasted expenditure including pre contract expenditure (in each case whether
                direct or indirect);
              </span>
            </h3>
          </li>
          <li className="c5 c9 li-bullet-1">
            <h3 style={{ display: 'inline' }}>
              <span className="c0">
                any actual or expected special, indirect or consequential loss of any type or pure economic loss
                including any loss arising out of the other party's liability to any other person, and whether or not
                reasonably foreseeable, reasonably contemplated or actually contemplated by the parties;
              </span>
            </h3>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={5}>
          <li className="c6 li-bullet-0">
            <span className="c0">Subject to Paragraph 1</span>
            <span>4</span>
            <span className="c0">
              .1, Markato's and its Affiliates' and their respective Representatives' total aggregate liability to you
              in contract, tort (including negligence), equity, statute, or any other cause, arising out of or in
              connection with: (i) any Order shall not exceed the amounts actually paid by you in respect of such
              Orders; and (ii) in all other cases, arising out of or in connection with these Retailer Terms (or any
              other Terms of Services), shall not exceed US$1,000..
            </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              You acknowledge that Markato shall rely on one or more Intermediary Service Providers for the purposes of
              providing the Services. The Intermediary Service Providers are independent third parties and are not
              Markato's agents or subcontractors. Subject to Paragraph 1
            </span>
            <span>4</span>
            <span className="c0">
              .1, Markato shall not be liable for the acts or omissions of any Intermediary Service Provider, including
              any Losses arising from the fault of any Intermediary Service Provider such as a failure by an
              Intermediary Service Provider to comply with applicable laws, the Payment Transaction Rules, or any
              reasonable instructions provided by Markato.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-0" start={15}>
          <li className="c7 c9 li-bullet-0">
            <h1 id="h.3as4poj" style={{ display: 'inline' }}>
              <span className="c3">Prohibited Uses</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c6 li-bullet-0">
            <span className="c0">
              Markato will have the right to investigate and prosecute violations of these Retailer Terms to the fullest
              extent permitted by law.{' '}
            </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              You acknowledge and agree that Markato has no obligation to monitor your access to or use of the Services,
              but has the right to do so for the purpose of operating the Services, to ensure your compliance with these
              Retailer Terms, to investigate a complaint or to comply with applicable law or the order or requirement of
              a court, administrative agency or other governmental body.{' '}
            </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              Markato reserves the right, at any time and without prior notice, to remove or disable access to any of
              Your Retailer Materials, in its sole discretion, considers to be in violation of these Retailer Terms,
              applicable laws or otherwise harmful to the Services.{' '}
            </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              Markato reserves the right to cooperate fully with law enforcement, and to involve and share information
              with law enforcement, governmental agencies or other oversight bodies if Markato suspects illegal activity
              may be taking place.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-0" start={16}>
          <li className="c7 c9 li-bullet-0">
            <h1 id="h.1pxezwc" style={{ display: 'inline' }}>
              <span className="c3">Termination</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c6 li-bullet-0">
            <span className="c0">
              Markato reserves the right to revoke your access to and use of the Services at any time, with or without
              cause. In the event Markato terminates these Retailer Terms for your breach, you will remain liable for
              all amounts due hereunder.{' '}
            </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              If you breach any of these Retailer Terms, Markato will have the right to temporarily suspend or
              permanently terminate your Retailer Account, and/or terminate these Retailer Terms, in its sole discretion
              and without prior notice to you.{' '}
            </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              You may terminate your relationship with Markato at any time by contacting us or as otherwise indicated in
              your Retailer Account portal. Markato will close your Retailer Account once there has been an accounting
              of all monies due and owing.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-0" start={17}>
          <li className="c7 c9 li-bullet-0">
            <h1 id="h.2p2csry" style={{ display: 'inline' }}>
              <span className="c3">applicable laws and Regulations</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c6 li-bullet-0">
            <span className="c0">
              You agree and understand that by opening a Retailer Account and using the Services in any capacity, you
              shall act in compliance with all applicable laws. Failure to do so may result in the suspension of your
              ability to use the Services or the closure of your Retailer Account.
            </span>
          </li>
          <li className="c6 li-bullet-0" id="h.147n2zr">
            <span className="c0">
              Without limitation to the above, your access to and use of your Retailer Account and the Services, and the
              receipt of any amounts due to you under these Retailer Terms, is subject to your continued compliance with
              all applicable laws, including the rules and directions of any applicable Regulatory Authority and,
              without limitation, all applicable tax, anti-money laundering (
            </span>
            <span className="c3">"AML"</span>
            <span className="c0">) and counter-terrorist financing (</span>
            <span className="c3">"CTF"</span>
            <span className="c0">) laws and regulations.</span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-0" start={18}>
          <li className="c7 c9 li-bullet-0">
            <h1 id="h.3o7alnk" style={{ display: 'inline' }}>
              <span className="c3">confidentiality</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c6 li-bullet-0" id="h.23ckvvd">
            <span className="c0">
              You shall treat as strictly confidential and not use or disclose any information or documents which you
              receive (or have received) from us, whether before, during or after the term of the Retailer Terms, and
              whether communicated orally, in writing, in electronic form or otherwise, relating to our business,
              financial situation, products and services (including the Services), expectations, processes and methods,
              customers or employees, in each case which is designated as being "confidential" or which by its very
              nature should obviously be treated as secret and confidential (together{' '}
            </span>
            <span className="c3">"Confidential Information"</span>
            <span className="c0">).</span>
          </li>
          <li className="c6 li-bullet-0" id="h.ihv636">
            <span className="c0">
              You may use the Confidential Information solely to the extent necessary to receive the benefit of the
              Services in accordance with the Retailer Terms.
            </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              The obligation to maintain confidentiality under this paragraph shall not apply to any Confidential
              Information to the extent that such information is:{' '}
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-2">
            <span className="c0">in the public domain through no breach of the Retailer Terms;</span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              known to you at the time of disclosure without restrictions on use, or independently developed by you, and
              in each case there is appropriate documentation to demonstrate either condition; or
            </span>
          </li>
          <li className="c2 li-bullet-1" id="h.32hioqz">
            <span className="c0">required to be disclosed to a Regulatory Authority or by applicable laws.</span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={4}>
          <li className="c6 li-bullet-0">
            <span className="c0">
              If you are required under applicable laws or by any Regulatory Authority to disclose Confidential
              Information you shall give us such notice as is practical in the circumstances of such disclosure and
              shall provide all cooperation reasonably requested by us in relation to mitigating the effects of, or
              avoiding the requirements for, any such disclosure.{' '}
            </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              Any Confidential Information shall remain the property of Markato and may be copied or reproduced only
              with our prior written consent.{' '}
            </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              Upon request, you shall return or destroy all materials containing our Confidential Information and, where
              such materials have been destroyed, confirm such destruction in writing. You shall be under no obligation
              to return or destroy such materials if and to the extent you are required to retain such materials under
              applicable laws, provided that you shall notify us in writing of such requirement, giving details of the
              materials which have not been destroyed or returned, and this paragraph shall continue to apply to such
              materials.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-0" start={19}>
          <li className="c7 c9 li-bullet-0">
            <h1 style={{ display: 'inline' }}>
              <span className="c3">PRIVACY POLICY</span>
            </h1>
          </li>
        </ol>
        <p className="c28 c30">
          <span className="c0">
            We are committed to protecting your personal information and to helping you understand exactly how your
            personal information is being used. You should carefully read our Privacy Policy, which provides details on
            how your personal information is collected, stored, protected, and used.
          </span>
        </p>
        <ol className="c1 lst-kix_list_1-0" start={20}>
          <li className="c7 c9 li-bullet-0">
            <h1 style={{ display: 'inline' }}>
              <span className="c3">cookies</span>
            </h1>
          </li>
        </ol>
        <p className="c30 c28">
          <span className="c0">
            By accessing the Site, you agree to use cookies in agreement with Markato's Privacy Policy. The Site uses
            cookies to enable us to retrieve user details for each visit, and to enable the functionality of certain
            areas of the Site to make it easier for users visiting the Site to access and use the Services.
          </span>
        </p>
        <ol className="c1 lst-kix_list_1-0" start={21}>
          <li className="c7 c9 li-bullet-0">
            <h1 style={{ display: 'inline' }}>
              <span className="c3">general</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Assignment and Subcontracting</span>
            </h2>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              You may not assign, novate, or otherwise transfer, any of your rights or obligations under the Retailer
              Terms, or sub-contract the performance of any of your obligations under the Retailer Terms, without the
              prior written consent of Markato. Any attempted assignment, novation, transfer or sub-contracting without
              our consent shall be void.
            </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              Markato may assign, novate, or otherwise transfer any of its rights or obligations under the Retailer
              Terms to any other person, or sub-contract the performance of any of its obligations under the Retailer
              Terms (including the performance of the Services), at any time and without your consent, and you hereby
              consent to such assignment, novation, transfer or subcontracting, and agree to take all actions (including
              by way of executing documents) and other assistance required by Markato to ensure that any such
              assignment, novation, transfer or subcontracting is effective and enforceable. If you object to such
              assignment, novation, transfer or sub-contracting you may terminate your relationship with Markato by
              contacting us or as otherwise indicated in your Retailer Account portal.
            </span>
          </li>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Entire agreement</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1" id="h.1hmsyys">
            <span className="c0">
              You agree that the Retailer Terms (together with the Terms of Service) constitute the entire agreement
              between you and Markato with respect to the use of the Services.
            </span>
          </li>
          <li className="c2 li-bullet-1" id="h.41mghml">
            <span className="c0">
              You agree that in agreeing to and entering into the Retailer Terms you have not been induced to do so by,
              and have not relied on, any statement, representation, warranty, assurance, covenant, indemnity,
              undertaking or commitment (
            </span>
            <span className="c3">"Representation"</span>
            <span className="c0">) which is not expressly set out in the Retailer Terms.</span>
          </li>
          <li className="c2 li-bullet-1" id="h.2grqrue">
            <span className="c0">
              You agree that your only right of action in relation to any innocent or negligent Representation set out
              in the Retailer Terms or given in connection with the Retailer Terms shall be for breach of contract. All
              other rights and remedies in relation to any such Representation (including those in tort or arising under
              statute) are excluded.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={5}>
          <li className="c7 c9 li-bullet-0">
            <h2 id="h.vx1227" style={{ display: 'inline' }}>
              <span className="c3">Notices</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Any notice (including any approval, consent or other communication) to be given in connection with these
              Retailer Terms (a "
            </span>
            <span className="c3">Notice</span>
            <span className="c0">") shall be in writing and in the English language.</span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              A Notice shall be duly and validly given or made if given or served by hand or sent by electronic mail, or
              pre-paid registered or recorded delivery post.
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Notices to a party shall be addressed to: (i) in the case of Markato, our contact details as listed on the
              Site or in the Application; and (ii) in the case of Retailer, the contact details submitted as part of
              registering your Retailer Account.
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">Any Notice given in accordance with this Paragraph 2</span>
            <span>1</span>
            <span className="c0">.5 shall be deemed to have been served or delivered: </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-3 start" start={1}>
          <li className="c10 li-bullet-0">
            <span className="c0">if given or served by hand, at the time of delivery;</span>
          </li>
          <li className="c10 li-bullet-0">
            <span className="c0">
              if sent by pre-paid registered or recorded delivery, on the second Business Day after the day of posting;
              or
            </span>
          </li>
          <li className="c10 li-bullet-0">
            <span className="c0">
              if sent by electronic mail, on the day on which the communication is sent and no report of non-delivery is
              received by the sender,
            </span>
          </li>
        </ol>
        <p className="c28 c23 c34">
          <span className="c0">
            provided that any notice deemed to have been served or delivered after 17:00 on any Business Day or at any
            time on a day other than a Business Day shall be deemed to have been served or given at 09:00 on the next
            Business Day.
          </span>
        </p>
        <ol className="c1 lst-kix_list_1-1" start={6}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Survival</span>
            </h2>
          </li>
        </ol>
        <p className="c17">
          <span className="c0">
            All rights and obligations of the parties that by their nature are continuing will survive the termination
            of the Retailer Terms.
          </span>
        </p>
        <ol className="c1 lst-kix_list_1-1" start={7}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Severability</span>
            </h2>
          </li>
        </ol>
        <p className="c17">
          <span className="c0">
            If any provision or part of the Retailer Terms is void or unenforceable due to any applicable laws, it shall
            be deemed to be deleted and the remaining provisions of the Retailer Terms shall continue in full force and
            effect. If any invalid, unenforceable or illegal provision of the Retailer Terms would be valid, enforceable
            and legal if some part of it were deleted, the provision shall apply with the minimum deletion necessary to
            make it valid, legal and enforceable.
          </span>
        </p>
        <ol className="c1 lst-kix_list_1-1" start={8}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Successors and assigns</span>
            </h2>
          </li>
        </ol>
        <p className="c17">
          <span className="c0">
            The Retailer Terms shall be binding on, and ensure to the benefit of, the parties to the Retailer Terms and
            their respective personal representatives, successors and permitted assigns, and references to any party
            shall include that party's personal representatives, successors and permitted assigns.
          </span>
        </p>
        <ol className="c1 lst-kix_list_1-1" start={9}>
          <li className="c7 c9 li-bullet-0">
            <h2 id="h.3fwokq0" style={{ display: 'inline' }}>
              <span className="c3">Variation and waiver</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-1" id="h.1v1yuxt">
            <span className="c0">
              No waiver by Markato of any right or remedy provided by the Retailer Terms or by law shall be effective
              unless it is in writing (which for this purpose, does not include email) and signed by, or on behalf of,
              Markato. The failure by Markato to exercise, or delay in exercising, any right or remedy provided by the
              Retailer Terms or by law does not: (i) constitute a waiver of that right or remedy; (ii) restrict any
              further exercise of that right or remedy; or (iii) affect any other rights or remedies. A single or
              partial exercise by Markato of any right or remedy does not prevent any further or other exercise of that
              right or remedy or the exercise of any other right or remedy.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={10}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">No partnership or agency</span>
            </h2>
          </li>
        </ol>
        <p className="c17">
          <span className="c0">
            Nothing in the Retailer Terms or in any matter or any arrangement contemplated by it is intended to
            constitute a partnership, association, joint venture, fiduciary relationship or other co-operative entity
            between the parties for any purpose whatsoever. Except as expressly provided in the Retailer Terms, neither
            party has any power or authority to bind the other party or impose any obligations on it and neither party
            shall purport to do so or hold itself out as capable of doing so. Each party confirms it is acting on its
            own behalf and not for the benefit of any other person.
          </span>
        </p>
        <ol className="c1 lst-kix_list_1-1" start={11}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Set off</span>
            </h2>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-2 start" start={1}>
          <li className="c2 li-bullet-2">
            <span className="c0">
              Notwithstanding that any amount is from time to time payable by Markato to you under or by virtue of the
              Retailer Terms or otherwise, you shall not set off such amount against any amount payable by you to
              Markato under the Retailer Terms.
            </span>
          </li>
          <li className="c2 li-bullet-1">
            <span className="c0">
              Markato may set off any amounts which from time to time are payable by Markato to you under or by virtue
              of the Retailer Terms or otherwise against any amounts payable by you to Markato under the Retailer Terms.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={12}>
          <li className="c7 c9 li-bullet-0">
            <h2 id="h.4f1mdlm" style={{ display: 'inline' }}>
              <span className="c3">Equitable remedies </span>
            </h2>
          </li>
        </ol>
        <p className="c17">
          <span className="c0">
            Without prejudice to any other rights or remedies that Markato may have, you acknowledge and agree that
            damages alone may not be an adequate remedy for your breach of the Retailer Terms. The remedies of
            injunction and specific performance as well as any other equitable relief for any threatened or actual
            breach of such provisions of the Retailer Terms may be more appropriate remedies.
          </span>
        </p>
        <ol className="c1 lst-kix_list_1-1" start={13}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Third party rights</span>
            </h2>
          </li>
        </ol>
        <p className="c30 c28">
          <span className="c0">Save as otherwise expressly provided in the Retailer Terms: </span>
        </p>
        <ol className="c1 lst-kix_list_1-2" start={3}>
          <li className="c2 li-bullet-1">
            <span className="c0">
              the Retailer Terms are not intended and shall not be construed to create any rights or remedies in any
              parties other than you and Markato and its Affiliates, which each shall be a third party beneficiary of
              the Retailer Terms; and{' '}
            </span>
          </li>
          <li className="c2 li-bullet-2">
            <span className="c0">
              no other person shall assert any rights as a third party beneficiary hereunder (notwithstanding any
              legislation to the contrary anywhere in the world).
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1" start={14}>
          <li className="c7 c9 li-bullet-0">
            <h2 id="h.2u6wntf" style={{ display: 'inline' }}>
              <span className="c3">Counterparts</span>
            </h2>
          </li>
        </ol>
        <p className="c17">
          <span className="c0">
            The Retailer Terms may be executed in any number of counterparts and by each party on separate counterparts,
            each of which when executed shall be an original, but all the counterparts together constitute one
            instrument.
          </span>
        </p>
        <ol className="c1 lst-kix_list_1-1" start={15}>
          <li className="c7 c9 li-bullet-0">
            <h2 style={{ display: 'inline' }}>
              <span className="c3">Electronic signature</span>
            </h2>
          </li>
        </ol>
        <p className="c30 c28">
          <span className="c0">The Retailer Terms may be entered into by electronic means.</span>
        </p>
        <ol className="c1 lst-kix_list_1-0" start={22}>
          <li className="c7 c9 li-bullet-0">
            <h1 style={{ display: 'inline' }}>
              <span className="c3">Controlling law and jurisdiction</span>
            </h1>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_1-1 start" start={1}>
          <li className="c6 li-bullet-0">
            <span className="c0">
              These Retailer Terms and any Dispute shall be governed by the laws of Hong Kong.{' '}
            </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              To the extent permitted by applicable law, the application of the United Nations Convention on Contracts
              for the International Sale of Goods, private international laws (e.g. conflict of laws principles) and
              consumer protection e-commerce regulations, where relevant, are expressly excluded.
            </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              Each party irrevocably agrees that the Courts of Hong Kong shall have exclusive jurisdiction in relation
              to any Dispute.
            </span>
          </li>
          <li className="c6 li-bullet-0">
            <span className="c0">
              Each party irrevocably waives any right that it may have to object to an action being brought in those
              Courts, to claim that the action has been brought in an inconvenient forum, or to claim that those Courts
              do not have jurisdiction.]
            </span>
          </li>
          <li className="c6 li-bullet-0" id="h.19c6y18">
            <span className="c0">
              For any disputes regarding an order or product from a Brand, you may contact Markato to help resolve the
              issue. Markato will use good faith efforts to assist you and the applicable Brand to resolve such dispute.
            </span>
          </li>
        </ol>
        <hr style={{ pageBreakBefore: 'always', display: 'none' }} />
        <p className="c26">
          <span className="c0" />
        </p>
        <ol className="c1 lst-kix_list_1-0" start={23}>
          <li className="c7 c9 li-bullet-0">
            <h1 id="h.3tbugp1" style={{ display: 'inline' }}>
              <span className="c3">Key Definitions</span>
            </h1>
          </li>
        </ol>

        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Affiliate"</span>
          <span className="c0">
            &nbsp;means, in relation to any person, any other person directly or indirectly Controlled by, or
            Controlling, or under common Control with, that person.
          </span>
        </p>

        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Brand"</span>
          <span className="c0">
            &nbsp;means a seller who offers to sell and/or sells its Products to Retailers through the Services. The
            term “Brand” also includes “Distributor” as defined below.
          </span>
        </p>
        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Business Day</span>
          <span className="c0">
            ” means a day (other than a Saturday or Sunday) on which commercial banks are open for business to the
            general public in both: (i) the location in which the Services are provided to you; and (ii) the location of
            Markato's corporate office (as identified at the start of these Retailer Terms).
          </span>
        </p>
        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Content</span>
          <span className="c0">
            " means Marks, applications, tools, text, audio, video, photographs, graphics, links, summaries, features,
            stories, terms and conditions and other data or information;
          </span>
        </p>
        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Control</span>
          <span className="c0">
            " means the power of a person to secure, directly or indirectly, (whether by the holding of shares,
            possession of voting rights or by virtue of any other power conferred by the articles of association,
            constitution, partnership deed or other documents regulating another person or otherwise) that the affairs
            of such other person are conducted in accordance with their or its wishes.
          </span>
        </p>
        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Dispute</span>
          <span className="c0">
            " means any dispute, claim, controversy or difference arising out of or in connection with these Retailer
            Terms, including any question regarding its existence, validity, subject matter, interpretation,
            negotiation, termination or enforceability.
          </span>
        </p>
        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Distributor"</span>
          <span className="c0">
            &nbsp;means a seller who offers to sell and/or sells a third party brand’s Products to Retailers on the
            Services under express, valid and continuous authorization from such third party brand.
          </span>
        </p>
        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Intellectual Property Rights"</span>
          <span className="c0">&nbsp;or "</span>
          <span className="c3">IP</span>
          <span className="c0">
            " means all intellectual property rights, including copyrights (including databases and other compilations
            of information), moral rights, patent rights, trade secrets and know-how, confidential information, trade
            marks, trade names, and service marks, domain names, get-up, logos, registered and unregistered design
            rights (including applications for, and registrations, extensions, renewals, and re-issuances of, the
            foregoing),and any other intellectual property or proprietary rights and all other similar rights in or to
            intangible property recognized in any jurisdiction in the world, now or hereafter existing, whether or not
            registered or registrable.
          </span>
        </p>
        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Intermediary Service Provider</span>
          <span className="c0">
            " means any third party supplier, consultant or other person engaged by or on behalf of Markato, whether
            directly or indirectly, for the purposes of enabling Markato to provide the Services, including any Payments
            Processor, but excluding any Representatives of Markato.
          </span>
        </p>
        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Losses</span>
          <span className="c0">
            " means claims, liabilities, expenses, fines, penalties, costs, losses or damages of whatever nature
            (including legal costs on a full indemnity basis).
          </span>
        </p>
        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Marks</span>
          <span className="c0">
            " means any trade mark, service mark, trade name, trade dress, get up, brand, logo, tagline, slogan, product
            name, corporate name, internet domain name or other designation or distinctive sign whether registered or
            not (including any applications or registrations related thereto and the goodwill associated therewith).
          </span>
        </p>
        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Product Guidelines</span>
          <span className="c0">
            " means Markato's guidelines for any products to be sold or purchased via the Services. Markato shall make
            available to you the Product Guidelines via the Services. Markato reserves the right to modify the Product
            Guidelines, in its sole and absolute discretion, from time to time.
          </span>
        </p>
        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Products</span>
          <span className="c0">" means the products which a Brand makes available for sale through the Services.</span>
        </p>
        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Regulatory Authority</span>
          <span className="c0">
            " means any foreign, domestic, state, federal, cantonal, municipal or local governmental, executive,
            legislative, judicial, administrative, supervisory or regulatory authority, agency, quasi-governmental
            authority, court, commission, government organisation, self-regulatory organisation having regulatory
            authority, tribunal, arbitration tribunal or panel or supra-national organisation, or any division or
            instrumentality thereof, including any tax authority.
          </span>
        </p>
        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Representatives</span>
          <span className="c0">
            " means, in relation to a party, its directors, officers, employees, agents, permitted contractors and
            subcontractors, permitted sub-licensees, and professional advisers.
          </span>
        </p>
        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Retailer Addendum</span>
          <span className="c0">
            " means any Retailer Addendum that we agree to enter into with you. The purpose of a Retailer Addendum is to
            set out certain additional terms and conditions which we have agreed shall apply to your access and use of,
            and our provision of, the Site, Application and Services. You acknowledge that we reserve the right to agree
            a Retailer Addendum with you in our sole and absolute discretion.
          </span>
        </p>
        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Retailer"</span>
          <span className="c0">
            &nbsp;means a buyer who purchases Products through the Services for the purpose of resale.
          </span>
        </p>
        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Retailer Information</span>
          <span className="c0">
            " means all information (including Confidential Information) disclosed or made available by you to us,
            whether directly or indirectly, in relation to your application for, or operation or maintenance of, a Brand
            Account and/or use the Services, including pursuant to Paragraph 3.1.
          </span>
        </p>
        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Returns, Refunds and Cancellations Policy</span>
          <span className="c0">
            " means Markato's policy for the return of any Product, the refund of amounts paid in respect of any
            Product, and the cancellation of any Order, via the Services. Markato shall make available to you the
            Returns, Refunds and Cancellations Policy via the Services. Markato reserves the right to modify the
            Returns, Refunds and Cancellations Policy in its sole and absolute discretion, from time to time.
          </span>
        </p>
        <p className="c11">
          <span className="c0">"</span>
          <span className="c3">Settlement Data</span>
          <span className="c0">" has the meaning given to it in the Airwallex Terms.</span>
        </p>
        <p className="c21">
          <span className="c0" />
        </p>
      </div>
    </main>
  )
}

export default TermsAndConditions


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/retailer-terms/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  